import { createSingleEntityStore } from '@core/ngrx-legacy';
import type { OnboardingVideosWatched } from '@core/onboarding-lib-types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<OnboardingVideosWatched>()('onboarding-videos');

const { update, updateSuccess, updateFailed } = actions;
const OnboardingVideosActions = { update, updateSuccess, updateFailed };

export {
  OnboardingVideosActions,
  selectors as OnboardingVideosSelectors,
  reducer as OnboardingVideosReducer,
  namespace as OnboardingVideosNamespace,
};
